import { AlertCircle, CheckCircle2, Database } from "lucide-react";
import React from "react";
import { Badge } from "@/components/ui/badge";
import {
  Card,
  CardContent,
  CardDescription,
  CardHeader,
  CardTitle,
} from "@/components/ui/card";
import { ScaledThumbnail } from "./ScaledThumbnail";

interface DataSourcesCardThumbnailProps {
  isHovered?: boolean;
  alwaysVisible?: boolean;
}

const SOURCES = [
  {
    name: "Access Financials",
    type: "Accounting — Access Financials",
    connected: true,
    lastSync: "2 minutes ago",
    records: "18,420 records",
  },
  {
    name: "Access Payroll",
    type: "Payroll — Access Payroll",
    connected: false,
    lastSync: "3 days ago",
    records: "1,204 records",
  },
];

export default function DataSourcesCardThumbnail({
  isHovered = false,
  alwaysVisible = false,
}: DataSourcesCardThumbnailProps) {
  return (
    <ScaledThumbnail
      isHovered={isHovered}
      alwaysVisible={alwaysVisible}
      contentWidth={380}
    >
      <div className="w-[380px] grid gap-4">
        {SOURCES.map((source) => (
          <Card key={source.name}>
            <CardHeader>
              <div className="flex items-start justify-between">
                <div className="flex items-center gap-3">
                  <div className="p-2 bg-primary/10 rounded-lg">
                    <Database className="h-5 w-5 text-primary" />
                  </div>
                  <div>
                    <CardTitle className="text-lg">{source.name}</CardTitle>
                    <CardDescription>{source.type}</CardDescription>
                  </div>
                </div>
                <Badge
                  variant={source.connected ? "default" : "secondary"}
                  className="gap-1"
                >
                  {source.connected ? (
                    <CheckCircle2 className="h-3 w-3" />
                  ) : (
                    <AlertCircle className="h-3 w-3" />
                  )}
                  {source.connected ? "Connected" : "Disconnected"}
                </Badge>
              </div>
            </CardHeader>
            <CardContent>
              <div className="space-y-1 text-sm">
                <p className="text-muted-foreground">
                  Last sync:{" "}
                  <span className="text-foreground font-medium">
                    {source.lastSync}
                  </span>
                </p>
                <p className="text-muted-foreground">
                  Synced:{" "}
                  <span className="text-foreground font-medium">
                    {source.records}
                  </span>
                </p>
              </div>
            </CardContent>
          </Card>
        ))}
      </div>
    </ScaledThumbnail>
  );
}

export { DataSourcesCardThumbnail };
